import createDocumentResource from 'src/actions/shared/createDocumentResource';

class TaskRouting {
  routingWindowInSeconds: string;
}

const taskRouting = createDocumentResource<TaskRouting>({
  name: 'taskRouting',
  endpoint: 'v1/orgs/:orgId/configuration/task-routing',
  type: TaskRouting,
});

export default taskRouting;
